import { EventGroup } from '../enumerations';
import {
  handleUrl,
  myHeadersWithToken,
  myHeadersWithTokenContentType,
} from '../global';
import {
  DetailProps,
  LoginLayoutProps,
  LoginParams,
  LoginProps,
} from './types';

export const login = ({
  email,
  password,
}: LoginParams): Promise<LoginProps> => {
  const myHeaders = myHeadersWithToken();
  myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');

  const urlencoded = new URLSearchParams();
  urlencoded.append('username', email);
  urlencoded.append('password', password);

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: urlencoded,
  };

  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/login/control`, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => new Error(error));
};

export const getLoginLayout = (): Promise<LoginLayoutProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(EventGroup.BOOTSTRAP),
  };

  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/login`, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => new Error(error));
};

export const logout = (): Promise<Partial<DetailProps>> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(EventGroup.LOGOUT),
  };

  const baseURL = handleUrl();
  return fetch(`${baseURL}/api/V1/logout`, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => new Error(error));
};
